import { fetchAPI } from '.'

import type { AnalyticsEvent, ChangeSet, GlobalProperty, PublishPreviewSnapshot } from '@/pages/app/AnalyticsPortal/types'

export interface BatchSaveResponse {
  created: AnalyticsEvent[]
  updated: AnalyticsEvent[]
  errors: string[]
}

export async function getAnalyticsEvents() {
  return fetchAPI<AnalyticsEvent[]>({
    method: 'GET',
    url: '/api/v1/analytics-registry/events',
  })
}

export async function getGlobalProperties() {
  return fetchAPI<AnalyticsEvent>({
    method: 'GET',
    url: '/api/v1/analytics-registry/global-properties',
  })
}

export async function saveGlobalProperties(propertiesSchema: Record<string, GlobalProperty>) {
  return fetchAPI<AnalyticsEvent>({
    method: 'PATCH',
    url: '/api/v1/analytics-registry/global-properties',
    data: { properties_schema: propertiesSchema },
  })
}

export async function saveAnalyticsEvents(creates: Partial<AnalyticsEvent>[], updates: Partial<AnalyticsEvent>[]) {
  return fetchAPI<BatchSaveResponse>({
    method: 'POST',
    url: '/api/v1/analytics-registry/events',
    data: { creates, updates },
  })
}

export async function getPublishPreview() {
  return fetchAPI<PublishPreviewSnapshot>({
    method: 'GET',
    url: '/api/v1/analytics-registry/publish/preview',
  })
}

export async function publishAnalyticsRegistry() {
  return fetchAPI<ChangeSet>({
    method: 'POST',
    url: '/api/v1/analytics-registry/publish',
  })
}
